import e from "./Stats.vue_rollup-plugin-vue=script.js";
export default (function (e, t, s, n, r, a, i, u) {
  var c = ("function" == typeof s ? s.options : s) || {};
  return c.__file = "Stats.vue", c.render || (c.render = e.render, c.staticRenderFns = e.staticRenderFns, c._compiled = !0, r && (c.functional = !0)), c._scopeId = n, c;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        s = e._self._c || t;
    return e.state ? s("div", {
      class: e.suit()
    }, [e._t("default", function () {
      return [s("span", {
        class: e.suit("text")
      }, [e.state.areHitsSorted ? [e._v(e._s(e.sortedResultsSentence))] : [e._v(e._s(e.resultsSentence))], e._v(" found in " + e._s(e.state.processingTimeMS.toLocaleString()) + "ms")], 2)];
    }, {
      results: e.state.instantSearchInstance.helper.lastResults
    }, e.state)], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);